<template>
   <footer class="copyright bg-black">
		<div class="text-center">
			<p class="text-center">Copyright © 2015. McCain. Todos los derechos reservados. Política de privacidad global.</p>
		</div>
	</footer>
</template>
<script>
export default {
	name: "FooterCopyright",
	props: {

	},
	data() {
		return {
		}
	},
}
</script>